import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OrganizationService } from '../../services/organization.services';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToolBarComponent } from '../../components/tool-bar/tool-bar.component';
import { TableModule } from 'primeng/table';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { HttpClientModule } from '@angular/common/http';
import { Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { ViewChild } from '@angular/core';
import { MenuModule } from 'primeng/menu';


@Component({
  selector: 'app-organizations',
  standalone: true,
  imports: [
    CommonModule, ToolBarComponent, DialogModule, InputTextModule, ButtonModule,
    ReactiveFormsModule, FormsModule, TableModule, HttpClientModule, ProgressSpinnerModule, MenuModule,
  ],
  templateUrl: './organizations.component.html',
  styleUrl: './organizations.component.scss'
})
export class OrganizationsComponent implements OnInit {
  showAddModal = false;
  organizationForm: FormGroup;

  organizations: any[] = [];
  totalRecords = 0;
  rows = 50;
  loading = false;
  selectedOrganizations: any[] = [];
  tenant_id: string = '';
  editMode = false;
  editingOrgId: string | null = null;
  searchText: string = '';
  searchAttribute: string = '';
  searchFilters = [
    { label: 'Name', value: 'name' },
    { label: 'Type', value: 'type' }
  ];
  dateFrom: string | null = null;
  dateTo: string | null = null;
  isSaving = false;
  @ViewChild('actionMenu') actionMenu: any;

  actionItems: MenuItem[] = [];
  selectedOrgForAction: any;



  constructor(private fb: FormBuilder, private orgService: OrganizationService, private api: OrganizationService, private localStorage: LocalStorageService, private router: Router,
    private messageService: MessageService
  ) {
    this.organizationForm = this.fb.group({
      name: ['', Validators.required],
      type: ['', Validators.required],
      address: [null],
      city: [null],
      state: [null],
      country: [null],
      postal_code: [null, [Validators.pattern(/^\d{1,6}$/)]],
      contact_number: [null, [Validators.required, Validators.pattern(/^\d{10}$/)]],
      email: [null, [Validators.required, Validators.email]],
      website: [null],
      establishment_year: [null, [Validators.pattern(/^\d{4}$/)]],
      registration_number: [null],
      accreditation: [null],
      logo_url: [null],
      second_logo_url: [null],
      institution_code: [null, Validators.required],
      bot_client_id: [null]
    });
  }

  ngOnInit(): void {
    this.tenant_id = this.localStorage.getOrganizationId();
    this.loadOrganizations({ first: 0, rows: this.rows });
  }

  openAddModal() {
    this.showAddModal = true;
  }

  closeAddModal() {
    this.showAddModal = false;
  }
  viewOrganization(org: any) {
    console.log('Viewing organization:', org);
    // You could open a modal here to show details or navigate to a detail page
    if (org && org.organization_id) {
      this.router.navigate(['/main/organizations', org.organization_id]);
    }
  }

  handleSearch(event: any) {
    this.searchText = event.value || '';
    this.searchAttribute = event.selectedFilterAttribute || 'name';
    this.loadOrganizations({ first: 0, rows: 10 }, this.searchText, this.searchAttribute);
  }

  handleDateFilter(event: any) {
    this.dateFrom = event.startDate;
    this.dateTo = event.endDate;
    this.loadOrganizations({ first: 0, rows: 10 }, this.searchText, this.searchAttribute);
  }

  handleResetDateFilter() {
    this.dateFrom = null;
    this.dateTo = null;
    this.loadOrganizations({ first: 0, rows: 10 }, this.searchText, this.searchAttribute);
  }

  saveOrganization() {
    if (this.organizationForm.valid && this.tenant_id) {
      this.isSaving = true;
      const payload = {
        ...this.organizationForm.value,
        tenant_id: this.tenant_id,
        organization_id: this.editingOrgId || undefined
      };
      if (!this.editMode) {
        this.orgService.createOrganization(payload).subscribe({
          next: () => {
            this.isSaving = false;
            this.closeAddModal();
            this.organizationForm.reset();
            this.editMode = false;
            this.editingOrgId = null;
            this.loadOrganizations({ first: 0, rows: this.rows }); // Reload table
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: this.editMode ? 'Organization updated successfully!' : 'Organization created successfully!'
            });
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to save organization. Please try again.'
            });
            console.error('❌ Failed to save organization:', err);
            this.isSaving = false;
          }
        });
      } else {
        this.orgService.updateOrganization(payload).subscribe({
          next: () => {
            this.isSaving = false;
            this.closeAddModal();
            this.organizationForm.reset();
            this.editMode = false;
            this.editingOrgId = null;
            this.loadOrganizations({ first: 0, rows: this.rows }); // Reload table
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Organization updated successfully!'
            });
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to update organization. Please try again.'
            });
            console.error('❌ Failed to update organization:', err);
            this.isSaving = false;
          }
        });

      }
    } else {
      this.organizationForm.markAllAsTouched();
    }
  }
  loadOrganizations(event: any, searchValue?: string, searchAttribute?: string) {
    this.loading = true;

    const page = event.first / event.rows;
    const size = event.rows;

    const body: any = {
      where: {},
      filter: null,
      page: page,
      limit: size,
      order: {
        col: "\"organization\".\"updatedAt\"",
        dir: "DESC"
      }
    };

    if (searchValue && searchAttribute) {
      body.filter = {
        [searchAttribute]: searchValue
      };
    }

    // 📅 Date filter
    if (this.dateFrom && this.dateTo) {
      body.where['createdAt'] = {
        gte: this.dateFrom,
        lte: this.dateTo
      };
    }
    console.log('📤 Request Body:', body); // 👈 log the payload
    this.api.getAllOrgWithCount(body).subscribe({
      next: (data) => {
        console.log('✅ Response Data:', data); // 👈 log the response
        this.organizations = data.rows;
        this.totalRecords = data.count;
        this.loading = false;
      },
      error: (err) => {
        console.error('❌ API Error:', err); // 👈 log errors
        this.loading = false;
      }
    });

  }
  // Call this when clicking the edit (pencil) icon
  editOrganization(orgData: any) {
    if (!orgData) return;
    this.editMode = true;
    this.editingOrgId = orgData.organization_id;
    this.organizationForm.patchValue({
      name: orgData.name,
      type: orgData.type,
      address: orgData.address,
      city: orgData.city,
      state: orgData.state,
      country: orgData.country,
      postal_code: orgData.postal_code,
      contact_number: orgData.contact_number,
      email: orgData.email,
      website: orgData.website,
      establishment_year: orgData.establishment_year,
      registration_number: orgData.registration_number,
      accreditation: orgData.accreditation,
      logo_url: orgData.logo_url,
      second_logo_url: orgData.second_logo_url,
      institution_code: orgData.institution_code,
      bot_client_id: orgData.bot_client_id
    });
    this.showAddModal = true;

    // this.api.getOrganizationById({ organization_id: orgId }).subscribe({
    //   next: (orgData) => {
    //     this.organizationForm.patchValue(orgData); // or orgData.data if wrapped
    //     this.editMode = true;
    //     this.editingOrgId = orgId;
    //     this.showAddModal = true;
    //   },
    //   error: (err) => {
    //     console.error('❌ Failed to fetch organization:', err);
    //   }
    // });
  }

  // Call this when clicking the delete (trash) icon
  deleteOrganization(orgId: string) {
    if (!orgId) return;

    if (confirm('Are you sure you want to delete this organization?')) {
      this.api.deleteOrganization({ organization_id: orgId }).subscribe({
        next: () => {
          this.loadOrganizations({ first: 0, rows: this.rows });
        },
        error: (err) => {
          console.error('❌ Failed to delete organization:', err);
        }
      });
    }
  }
  openMenu(event: Event, org: any) {
    this.selectedOrgForAction = org;
    this.actionItems = [
      {
        label: 'View',
        icon: 'pi pi-eye',
        command: () => this.viewOrganization(org)
      },
      {
        label: 'Edit',
        icon: 'pi pi-pencil',
        command: () => this.editOrganization(org)
      },
      {
        label: 'Delete',
        icon: 'pi pi-trash',
        styleClass: 'delete-menu-item',
        command: () => this.deleteOrganization(org.organization_id)
      }
    ];
    this.actionMenu.toggle(event);
  }



}



